import React from "react"

const ShowMe = ({which, text, onClick, isActive}) => (
  <h1
    className={isActive ? "show-me-photos active" : "show-me-photos"}
    onClick={() => onClick(which)}>{text.toUpperCase()}</h1>
)

export default ShowMe